// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
  width: 100%;
  table-layout: fixed;
}
table tr {
  height: 45px;
  padding-top: 10px;
}

.link {
  cursor: pointer;
}
.link:hover {
  text-decoration: underline;
}

.selected {
  background-color: #E3F5FF;
}

.file-name-container {
  display: flex;
}
.file-name-container .link {
  flex: auto;
}

::ng-deep .mat-mdc-text-field-wrapper {
  background-color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/file-explorer/file-explorer.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,mBAAA;AACF;AACE;EACE,YAAA;EACA,iBAAA;AACJ;;AAIA;EACE,eAAA;AADF;AAGE;EACE,0BAAA;AADJ;;AAKA;EACE,yBAAA;AAFF;;AAKA;EACE,aAAA;AAFF;AAIE;EACE,UAAA;AAFJ;;AAKA;EACE,kCAAA;AAFF","sourcesContent":["table {\r\n  width: 100%;\r\n  table-layout: fixed;\r\n\r\n  tr {\r\n    height: 45px;\r\n    padding-top: 10px;\r\n    //border-bottom: 1px solid #ebebeb;\r\n  }\r\n}\r\n\r\n.link {\r\n  cursor: pointer;\r\n\r\n  &:hover {\r\n    text-decoration: underline;\r\n  }\r\n}\r\n\r\n.selected {\r\n  background-color: #E3F5FF;\r\n}\r\n\r\n.file-name-container {\r\n  display: flex;\r\n\r\n  .link {\r\n    flex: auto;\r\n  }\r\n}\r\n::ng-deep .mat-mdc-text-field-wrapper {\r\n  background-color: white !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
